export default __webpack_public_path__ + "static/media/Animals_13.5ecd0bce.png";